import React from "react";
import styled from "styled-components";
import philosopher from "url:./philosopher.svg";

const DescriptionWrapper = styled.div`
	font-size: 1.3em;
`;

const Quote = styled.p`
	font-face: serif;
	font-style: italic;
`;

const AppGo = styled.p`
	text-align: center;
`;

const Description = ({ viewDescription, setViewDesciption }) =>
	!viewDescription ? null : (
		<DescriptionWrapper>
			<p>
				<img
					src={philosopher}
					alt="Portrait of Hegel"
					style={{
						width: 100,
						float: "left",
						marginRight: 12,
						border: "1px solid purple",
					}}
				/>
				The Hegel app is a free and open source tool based on the{" "}
				<a
					href="https://en.wikipedia.org/wiki/Dialectic"
					rel="noreferrer"
					target="_blank"
				>
					dialectic
				</a>{" "}
				of{" "}
				<a
					href="https://plato.stanford.edu/entries/hegel/"
					rel="noreferrer"
					target="_blank"
				>
					Georg Wilhelm Friedrich Hegel
				</a>
				. In popular culture, it has taken a form of Problem, Reaction,
				Solution. Another way to think of it is as understanding a concept by
				negating it and finding a larger idea embedded within the original. This
				tool works by supplying:
			</p>
			<ul>
				<li>
					<strong>Concept</strong>: The idea you want to evolve.
				</li>
				<li>
					<strong>Negation</strong>: What the original concept is not.
				</li>
				<li>
					<strong>Synthesis</strong>: An idea which encompasses both the
					original and its negation.
				</li>
			</ul>
			<AppGo>
				<button onClick={() => setViewDesciption(false)}>Skip to App</button>
			</AppGo>
			<p>
				It may feel natural when entering an idea such as <i>Justice</i> to
				supply <i>Injustice</i> as a negation. However, it may be more fruitful
				to think about what Justice really means to you and try to define the
				negation in positive terms (e.g. <i>Random outcomes</i> or whatever you
				arrive at). When it comes time to enter an idea that is neither one nor
				the other, it may be easy to say Banana. However, if you try to enter an
				idea that relates to both terms, the AHA moment arises ... you see that
				there is a bigger idea embedded in the original term, which was only
				apparent by viewing it in terms of its negation.
			</p>
			<div>
				Immanuel Kant, perhaps formulated the benefits of dialectic best:
			</div>
			<Quote>
				By Kant, it was employed to signify the logic of appearances or
				illusions, whether these arise from accident or error, or from those
				necessary limitations which, according to this philosopher, originate in
				the constitution of the human intellect.
			</Quote>
			<h4>About Hegel app</h4>
			<p>
				This app is licensed under GPL-3, uses no cookies or tracking. All
				functionality takes place within the browser.{" "}
			</p>
			<p>
				Source code is available on{" "}
				<a
					href="https://git.sr.ht/~djlooop/hegel"
					rel="noreferrer"
					target="blank"
				>
					sourcehut
				</a>
				. For questions or suggestions, please contact{" "}
				<a href="https://sr.ht/~djlooop/" rel="noreferrer" target="blank">
					djlooop
				</a>
			</p>
			<AppGo>
				<button onClick={() => setViewDesciption(false)}>Close</button>
			</AppGo>
		</DescriptionWrapper>
	);

export default Description;
